
import request from '../utils/request'
// 用户登录
export function login(data) {
    return request({
        url: "/User/login",
        method: "post",
        data: data
      });
}

// 用户更新
export function update(data) {
    return request({
        url: "/User/update",
        method: "put",
        data: data
      });
}

